import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import HeaderImage from "../assets/pdfHeaderImg";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const notAllowRoutesToCheckToken = [
  "/login",
  "/login-institution",
  "/onboarding-teacher",
  "/confirmation",
  "/register",
  "/register-hubspot",
  "/recovery-password",
  "/change-password",
];

export const htmlToPlainText = (html) => {
  let text = html
    .replace(/<br\s*\/?>/gi, "\n") // Reemplaza <br> con salto de línea
    .replace(/<\/p>/gi, "\n") // Añade un salto de línea al final de cada párrafo
    .replace(/<li>/gi, "\n• ") // Reemplaza <li> con un punto de viñeta y salto de línea
    .replace(/<\/li>/gi, "") // Elimina </li>
    .replace(/<\/ul>/gi, "\n") // Añade un salto de línea al final de las listas desordenadas
    .replace(/<\/ol>/gi, "\n") // Añade un salto de línea al final de las listas ordenadas
    .replace(/<h[1-6]>/gi, "\n") // Añade un salto de línea antes de cada encabezado
    .replace(/<\/h[1-6]>/gi, "\n") // Añade un salto de línea después de cada encabezado
    .replace(/<[^>]+>/g, ""); // Elimina el resto de las etiquetas HTML

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = text;
  return tempDiv.textContent || tempDiv.innerText || "";
};

export const htmlToMarkdown = (html) => {
  let markdown = html
    .replace(/<br\s*\/?>/gi, "  \n") // Convierte <br> en dos espacios y salto de línea
    .replace(/<\/p>/gi, "\n\n") // Dos saltos de línea al final de cada párrafo
    .replace(/<li>/gi, (match) =>
      html.match(/<ul[^>]*>[\s\S]*?<\/ul>/g) &&
      html.match(/<ul[^>]*>[\s\S]*?<\/ul>/g).includes(match)
        ? "* "
        : "1. "
    ) // Convierte <li> en listas de Markdown
    .replace(/<\/li>/gi, "") // Elimina </li>
    .replace(/<\/ul>/gi, "\n") // Añade un salto de línea al final de listas desordenadas
    .replace(/<\/ol>/gi, "\n") // Añade un salto de línea al final de listas ordenadas
    .replace(/<h([1-6])>/gi, (match, level) => "\n" + "#".repeat(level) + " ") // Convierte <h1> - <h6> en encabezados de Markdown
    .replace(/<\/h[1-6]>/gi, "\n") // Añade un salto de línea después de los encabezados
    .replace(/<[^>]+>/g, "") // Elimina el resto de las etiquetas HTML
    .replace(/<em>/gi, "*") // Convierte <em> en asteriscos para énfasis en Markdown
    .replace(/<\/em>/gi, "*"); // Convierte </em> en asteriscos para cerrar énfasis

  return markdown;
};

function htmlToPdfmake(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const tableLayout = {
    // Líneas horizontales
    hLineWidth: function(i, node) {
      return (i === 0 || i === node.table.body.length) ? 1 : 0.5;
    },
    // Líneas verticales
    vLineWidth: function(i, node) {
      return (i === 0 || i === node.table.widths.length) ? 1 : 0.5;
    },
    // Color de las líneas
    hLineColor: function(i, node) {
      return i === 0 || i === node.table.body.length ? '#f2f2f2' : '#cccccc';
    },
    vLineColor: function(i, node) {
      return i === 0 || i === node.table.widths.length ? '#f2f2f2' : '#cccccc';
    },
    // Relleno de las celdas: [izquierda, arriba, derecha, abajo]
    paddingLeft: function(i, node) { return 16; },
    paddingRight: function(i, node) { return 16; },
    paddingTop: function(i, node) { return 8; },
    paddingBottom: function(i, node) { return 8; },
    fillColor: function(rowIndex, node, columnIndex) {
      return rowIndex === 0 ? '#434964' : null; // Color de fondo gris para la cabecera
    },
  };
  

  function adjustFontSize(htmlFontSize) {
    return htmlFontSize * (3 / 4);
  }  

  function walkNode(node) {
    const nodeName = node.nodeName.toLowerCase();
    let content = [];

    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
      // Directamente añade texto si es un nodo de texto
      return { text: node.textContent.trim(), bold: false };
    }

    if (nodeName === 'br') {
      return '\n'; // Añade un salto de línea para <br> o <br/>
    }  

    if (nodeName === 'table') {
      let tableBody = [];
    
      // Asumiendo que todas las filas tienen el mismo número de columnas
      const numberOfColumns = node.rows[0].cells.length;
      let columnWidths = new Array(numberOfColumns).fill('auto'); // Todas las columnas menos la última son 'auto'
      // Obtener el texto de la cabecera de la última columna
      const headerText = node.rows[0].cells[numberOfColumns - 1].textContent.trim();

      // Establecer el ancho fijo solo si la cabecera de la última columna es 'Comentarios'
      if (headerText === 'Comentarios') {
        columnWidths[columnWidths.length - 1] = 250; // Ancho fijo para la última columna si su cabecera es 'Comentarios'
      }
    
      Array.from(node.rows).forEach((row, rowIndex) => {
        let rowData = [];
        Array.from(row.cells).forEach(cell => {
          const cellContent = cell.textContent.trim();
          const cellData = rowIndex === 0 
              ? { text: cellContent, style: 'tableHeader' } 
              : cellContent;
          rowData.push(cellData);
        });
        tableBody.push(rowData);
      });
    
      return {
        table: {
          headerRows: 1,
          widths: columnWidths, // Usa el arreglo dinámico para los anchos de columna
          body: tableBody,
        },
        layout: tableLayout
      };
    }

    // Procesar nodos de elemento
    Array.from(node.childNodes).forEach(childNode => {
      let childContent = walkNode(childNode);
    
      // Verifica si el nodo actual es un <strong> y aplica negrita solo a su contenido
      if (node.nodeName.toLowerCase() === 'strong') {
        childContent.bold = true;
    
        // Verifica si el contenido finaliza con dos puntos y asegura el espacio después
        if (typeof childContent.text === 'string' && childContent.text.endsWith(':')) {
          childContent.text += ' ';  // Añade un espacio después de los dos puntos
        }
      }
    
      if (childContent) {
        // Evita la duplicación agregando directamente objetos de contenido
        content.push(childContent);
      }
    });    

    if (content.length === 0) {
        return null;
    }

    // Convierte arrays de strings y '\n' en un solo string para pdfMake
    content = content.reduce((acc, item) => {
      if (typeof acc[acc.length - 1] === 'string' && typeof item === 'string') {
        return [...acc.slice(0, -1), acc[acc.length - 1] + item];
      }
      return [...acc, item];
    }, []);

    switch (nodeName) {
      case "h1": case "h2": case "h3": case "h4":
      return {
        text: content,
        fontSize: adjustFontSize({ h1: 24, h2: 22, h3: 20, h4: 18 }[nodeName]),
        bold: true,
        margin: [0, 24, 0, 10],// [izquierda, arriba, derecha, abajo]
      };
      case "p":
        return { 
          text: content.map(item => {
            if (typeof item === 'string' || item instanceof String) {
              return { text: item, bold: false };
            }
            return item;
          }),
          fontSize: adjustFontSize(16), 
          margin: [0, 8, 0, 8] 
        };
      case "strong":
        return { 
          text: content, 
          fontSize: adjustFontSize(16), 
          bold: true,
        };
      case 'ul': 
        return { 
          ul: content.map(item => (typeof item === 'string' ? { text: item } : item)), 
          margin: [20, 0, 0, 8] 
        };
      case 'ol': 
        return { 
          ol: content.map((item, index) => (typeof item === 'string' ? { text: item, number: index + 1 } : item)), 
          margin: [20, 0, 0, 8] 
        };
      case 'li': 
        return { 
          stack: content.map(item => typeof item === 'string' ? { text: item } : item),
          fontSize: adjustFontSize(16), 
          margin: [20, 8, 0, 8],// [izquierda, arriba, derecha, abajo]
        };
      default:
        return content.length > 0 ? content : '';
    } 
  };

  const elements = walkNode(doc.body);

  if (elements && elements.length > 0 && elements[0].margin) {
    elements[0].margin = [elements[0].margin[0], 20, elements[0].margin[2], elements[0].margin[3]];
  } else if (elements && elements.length > 0) {
      elements[0].margin = [0, 20, 0, 0];
  }

  return elements;
}


export const htmlToPdf = (labelText, name) => {
  const contentHtml = document.querySelector(".preview").innerHTML;

  const calculateRectangleWidth = (text) => {
    const baseWidth = 50; // Ancho base en puntos.
    const widthPerCharacter = 5; // Ancho adicional por carácter.
    return baseWidth + (text.length * widthPerCharacter);
  };
    
  const docDefinition = {
    info: {
      title: '',
      author: '',
      subject: '',
      keywords: '',
    },
    pageSize: 'Letter',
    pageMargins: [60, 120, 60, 80],// [izquierda, arriba, derecha, abajo]
    header: function(currentPage, pageCount, pageSize) {
      const rectangleWidth = calculateRectangleWidth(labelText);
      return {
        margin: [40, 20, 40, 0],
        stack: [
          {
            image: HeaderImage,
            width: 540,
          },
          {
            canvas: [
              {
                type: 'rect',
                x: 0, 
                y: 0, 
                w: rectangleWidth, 
                h: 20,
                r: 4, 
                color: '#434964',
              }
            ],
            margin: [0, 5, 0, 10], 
          },
          {
            columns: [
              {
                width: rectangleWidth,
                text: labelText,
                style: 'labelStyle',
                alignment: 'center',
              }
            ],
            margin: [0, -25, 0, 10], // Ajusta para mover el texto hacia arriba sobre el rectángulo del `canvas`
          },
        ],
        columnGap: 10,
      };
    },     
    footer: function(currentPage, pageCount) {
      // Obtener la fecha actual
      const today = new Date();
      // Formatear la fecha 
      const formattedDate = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate();
      return {
        margin: [40, 20, 40, 20], // [izquierda, arriba, derecha, abajo]
        stack: [
          {
            canvas: [
              {
                type: 'line',
                x1: 0, y1: 5,
                x2: 515, 
                y2: 5,
                lineWidth: 1,
                lineColor: 'black',
              }
            ],
            margin: [0, 0, 0, 10]
          },
          {
            text: '',
            margin: [0, 5, 0, 0],
          },
          {
            columns: [
              {
                text: `Creado por: ${name}`,
                alignment: 'center',
                fontSize: 10,
                margin: [4, 0]
              },
              {
                text: `Fecha de creación: ${formattedDate}`,
                alignment: 'center',
                fontSize: 10,
                margin: [0, 0]
              },
              {
                text: 'Visita nuestro sitio web',
                color: '#359ED5',
                decoration: 'underline',
                alignment: 'center',
                fontSize: 10,
                link: 'https://mentu.co/shaia',
                bold: true,
                margin: [4, 0]
              },
            ]
          }
        ]
      };
    }, 
    content: htmlToPdfmake(contentHtml),
    styles: {
      headerSpacer: {
        // 
      },
      labelStyle: {
        fontSize: 10,
        bold: true,
        color: 'white',
      },
      tableHeader: {
        bold: true,
        color: 'white',
      }    
    },
  };
  
  pdfMake.createPdf(docDefinition).download('documento.pdf');
}


export const getHistoryTitle = (content, indicator ) => {
  // Esta expresión regular maneja espacios opcionales y diferentes formatos del patrón del título.
  // Utiliza '^' para indicar que el patrón debe estar al inicio de la línea.
  const tituloRegex = /^(?:###\s*|##\s*|#\s*|)\s*Título\s*(.+?)(?=\n|$)/m;
  const match = content.match(tituloRegex);

  if (match && match[1]) {
    return match[1].trim();
  }
  return null;
}

export const getHistorySystemUser = (history) => {
  let currentUserMessage = null;
  if(history){
    const currentHistory = history.find(e => {
      const currentMemoryArray = JSON.parse(e.memory_array);
      const findUserMessage = currentMemoryArray.find(e => e?.role === "user" || e?.type === "human");
      return !!findUserMessage;
    })
    if(currentHistory){
      const historyMessages = JSON.parse(currentHistory.memory_array); 
      const findUserMessage = historyMessages?.find(
        (e) => e?.role === "user" || e?.type === "human"
      );
      const currentHistoryUserMessage = findUserMessage?.content || findUserMessage?.data?.content;
      if(currentHistoryUserMessage){
        currentUserMessage = currentHistoryUserMessage;
      }
    }
  }
  return currentUserMessage;
}

export  const parseForm = (text) => {
  const keyValuePairs = {};
  const reference = text.includes("Context:") ? "  " : "\n";
  const lines = text.split(reference);

  // Procesa cada línea
  lines.forEach((line) => {
    // Intenta encontrar pares clave-valor separados por ':'
    if (text.includes("contextoUsuario:") && line.includes(":")) {
      const [key, value] = line.split(":").map((part) => part.trim());
      keyValuePairs[key] = value;
    } else {
      // Si no hay ':', trata de dividir por dos espacios, como en el formato original
      const segments = line.split("  ");
      segments.forEach((segment) => {
        if (segment.trim() !== "") {
          const [key, value] = segment.split(":").map((part) => part.trim());
          keyValuePairs[key] = value;
        }
      });
    }
  });

  return keyValuePairs;
}

export const getBuildForm  = (formContext, questions) => {
  const extractedText = formContext.includes("```")
    ? formContext.match(/```([\s\S]*?)```/)[1]
    : formContext;
  const contextObject = parseForm(extractedText);
  const parsedQuestions = Object.keys(contextObject).reduce((acc, key) => {
    const findCurrentQuestion = questions.find((e) => e.question === key);
    if (findCurrentQuestion) {
      return [
        ...acc,
        { field: findCurrentQuestion.field, value: contextObject[key] },
      ];
    }
    return acc;
  }, []);

  return parsedQuestions
};
